import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './dev.scss'
import App from './App';
import './assets/scss/style.scss';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


reportWebVitals();
